import { first, shareReplay } from 'rxjs';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { Table } from 'primeng/table';
import saveAs from 'file-saver';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  display: boolean = false;  
  viewApplicationWorkFlowDiag = false;  
  statusData: string = 'Your application status is...';  
  selectedAppId: string | null = null;
  totalArea: number;
  totalLandArea: number;
  viewLinkMasked: boolean;
  userRole: string;
  
  // Method to show the dialog
  showDialog(row) {
  this.selectedAppId = row?.appID;
  this.viewApplicationWorkFlowDiag = true; 
  this.display = true; 
}
onApplicationSelect(appId: string) {
    this.selectedAppId = appId;                
    this.viewApplicationWorkFlowDiag = true;  
    this.display = true;                     
  }
  @ViewChild('dashboardTable', { static: true })
  public dashboardTable: Table;

  farmerAppDetails: any = [];
  farmerDetails: any;
  formData: any;
  village: any;
  villageList = [];
  filteredData: any[];
  isAtalbhujal: any;
  farmerId: any;
  farmerMobile: any;
  applicationDetails: any;
  appId: any;
  miDetailsByAppId: any;
  _appID: any;
  public loading: boolean = false;
  public subscriptions: any = []
  public subjectSub: any;
  public selectedYear: any;
  public appVerificationItems: MenuItem[];
  public appVerificationModel: any;
  public cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  public exportColumns: { title: string; dataKey: string; }[];
  private farmerConfData: any;
 

  constructor(
    public router: Router,
    private dashboard: DashboardService,
    private _personalDetalSer: FarmersDetailsService,
    private confirmationService: ConfirmationService,
    private productService: BankDetailService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService,
    private cdref: ChangeDetectorRef,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private _dashboardService: DashboardService,
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    this.farmerConfData = new Map(encData);

    this.farmerMobile = this.farmerConfData.get('farmerPh');

    // this.loadDataAndApplyFilter();
    this.loadData();

    //test start
    //this.farmerAppDetails.forEach(e => {
    // this.getMIDetailByAppID(this.farmerAppDetails.appID);
    // })
    //this.getMIDetailByAppID();

    //test end
    // this.getMIDetailByAppID(this._appID);
    // console.log("FarmerAppDetails",this.farmerAppDetails[0]?.appID);
    //  this._appID=this.farmerAppDetails[0]?.appID;
    // console.log("_appID",this._appID)
    //   this.dashboard
    //     .getMIDetailByAppID(this._appID)
    //     .pipe(first())
    //     .subscribe({
    //       next: (res) => {
    //         this.miDetailsByAppId = res;
    //         console.log("miDetailsByAppId", this.miDetailsByAppId);
    //       },
    //       error: (err) => {
    //         console.log("error", err);
    //         this.messageService.add({
    //           severity: 'error',
    //           summary: 'Error Message',
    //           detail: err,
    //         });
    //       },
    //     });
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "dashboard_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "dashboard_report");
        }
      },
    ];

  }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        this.loadData();

        this.selectedYear = res;
        this.dashboardTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  getApplicationDetails(appId) {
    this.loader.start();
    this._dashboardService.getApplicationByAppId(appId).subscribe((res) => {
      this.loader.close();
      if (res) {
        this.applicationDetails = res;

        // res.ListViewFormData = [
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   },
        //   {
        //     "AutoId": 372819,
        //     "ProgId": 2,
        //     "VendorId": "302",
        //     "User_ID": "farmer"
        //   }
        // ]

        if (res?.ListViewFormData && res?.ListViewFormData.length > 0) {
          res?.ListViewFormData.forEach((val) => {
            let autoId = val?.AutoId;
            let progId = val?.ProgId
            let userId = val?.User_ID;
            let vendorId = val?.VendorId;

            if (autoId!=null && userId!=null) {
              this.getCalculatedSubsidyDataForMIPhys(autoId, userId);
            }

            if (autoId!=null && progId!=null) {
              this.getPreEstimationData(this.appId, progId);
            }

            if (this.appId!=null && progId!=null) {
              this.getSanctionLetterData(this.appId, progId);
            }

            if (vendorId!=null && progId!=null) {
              this.getPreEstimationData(this.appId, vendorId, progId);
              this.getMIBOQData(this.appId, vendorId, progId);
            }

            if (autoId!=null && userId!=null) {
              this.getPhysicalSurveyData(autoId, userId);
            }
          });
        }

        if (
          this.applicationDetails?.FarmerLand &&
          this.applicationDetails?.FarmerLand.length > 0
        ) {
          this.applicationDetails?.FarmerLand.forEach(
            (val) => (this.totalLandArea += parseFloat(val.totalArea))
          );
        }

        this.totalArea = 0;
        if (this.applicationDetails?.New_MI_Datas && this.applicationDetails?.New_MI_Datas.length > 0) {
          this.applicationDetails.New_MI_Datas = this.applicationDetails.New_MI_Datas.filter((val) => {
            return (!(val?.miVendorName == null || val?.miVendorName == '') && !(val?.VendorCode == null && val?.VendorCode == 0))});
          this.applicationDetails.New_MI_Datas.forEach(
            (val) => (this.totalArea += parseFloat(val.totalArea))
          );
        }

        let farmerId = res.Farmer_ID;
        if (res?.GroupTableData) {
          this.getPastSubsidiesByMultipleFarmerIds(res?.GroupTableData);
        } else {
          this.getPastSubsidiesByFarmerId(farmerId);
        }
        if(this.applicationDetails?.FarmerPersonalData?.Aadhar_No){
          if(this.userRole && (this.userRole ==='DMICADA' || this.userRole ==='DD Associate' || this.userRole ==='CAO' || this.userRole == 'DD-EW' || this.userRole == 'JE-EW' || this.userRole == 'DDMI' || this.userRole == 'DDTank')){
              this.viewLinkMasked = false;
          }
          else{
            this.viewLinkMasked = true;
            this.applicationDetails.FarmerPersonalData.Aadhar_No=this.maskNumber(this.applicationDetails?.FarmerPersonalData?.Aadhar_No)
            this.applicationDetails.FarmerPersonalData.PPP_ID=this.maskNumber(this.applicationDetails?.FarmerPersonalData?.PPP_ID)
          }
        }
      }
    },
    _err => {
      this.loader.close();
    });
  }
  maskNumber(_PPP_ID: any): any {
    throw new Error('Method not implemented.');
  }
  getPastSubsidiesByFarmerId(_farmerId: any) {
    throw new Error('Method not implemented.');
  }
  getPastSubsidiesByMultipleFarmerIds(_GroupTableData: any) {
    throw new Error('Method not implemented.');
  }
  getPhysicalSurveyData(_autoId: any, _userId: any) {
    throw new Error('Method not implemented.');
  }
  getMIBOQData(_appId: any, _vendorId: any, _progId: any) {
    throw new Error('Method not implemented.');
  }
  getSanctionLetterData(_appId: any, _progId: any) {
    throw new Error('Method not implemented.');
  }
  getPreEstimationData(_appId: any, _progId: any, progId?: any, ) {
    throw new Error('Method not implemented.');
  }
  getCalculatedSubsidyDataForMIPhys(_autoId: any, _userId: any) {
    throw new Error('Method not implemented.');
  }
  refreshTable() {
    this.loadData();
  }

  loadData() {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);

    const AtalbhujalRole = loginDetails.get('isAtalBhujal') ? loginDetails.get('isAtalBhujal') : null;

    // let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    //   let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    //  this.appId= JSON.parse(payload)?.sub;
    // this.appId=t his.appID;

    if (AtalbhujalRole == "1") {
      
      const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
      const loginDetails = new Map(encDataD);
      const atalBhujalUserID = loginDetails.get('atalBhujalUserID') ? loginDetails.get('atalBhujalUserID') : null;
      
      this.isAtalbhujal = true;
      let userId = atalBhujalUserID;
      this.getFarmerAppDetailsByAtalLogin(userId);
    }
    else {
      const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
      const farmerConfData = new Map(encData);
      this.farmerId = farmerConfData.get('Farmer_Id_');

      // this.getFarmerPhone();
      if(this.farmerId) {
        this.getDetailsByFarmerId();
      }else{
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "Complete your KYC first." });
      }
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ApplicationWorkFlowDiag() {
    this.viewApplicationWorkFlowDiag = true;
    // <app-ApplicationworkFlowDiag></app-ApplicationworkFlowDiag>
    // this.router.navigate([
    //   `dashboard/${this.route.snapshot.paramMap.get(
    //     'appId'
    //   )}`,
    // ]);
    return this.applicationDetails?.APP_ID;
  }

  getFarmerAppDetailsByAtalLogin(userId: any) {
    // this.loader.start();
    this.loading = true;
    let sub = this.dashboard.getApplicationByAtal(userId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          res.forEach(e => {
            e.registerationDate = new Date(e.registerationDate)
            e.registerationDate_filter = e.registerationDate.toString().substring(4, 15)
          })
          this.farmerAppDetails = res;
          this.appVerificationModel = this.farmerAppDetails;
          // this.loader.close();
          this.loading = false;
          // console.log("appdetails", this.farmerAppDetails);
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
        }
      })

    this.subscriptions.push(sub);
  }

  onAtalbhujalFarmer() {
    sessionStorage.removeItem('farmerDetails');
    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('farmerPh');
    sessionStorage.removeItem("isFarmerLogin");

    // new confidentidal encrypted data
    sessionStorage.removeItem('dataF')
    
    this.router.navigate(['/phone-login']);
  }

  getFarmerPhone() {
    // this.loader.start();
    this.loading = true;
    let sub = this.productService.getFarmerIdByMobileNo(this.farmerMobile).subscribe(resp => {
      // this.loader.close();
      this.loading = false;
      if (resp.statusCode === 200) {
        // this.activityRecordService.activityRecord(this.farmerMobile, 'Farmer Dashboard', '', new Date(), 'Success');
        let far = JSON.parse(resp.data);
        if (far.length > 0) {
          this.farmerId = far[0].Farmer_ID;
          this.getDetailsByFarmerId();

          this.farmerConfData.set("farmerId", this.farmerId);

          const dataF = JSON.stringify(Array.from(this.farmerConfData.entries()));
          sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));
        }
      }
      else {
        // this.activityRecordService.activityRecord(this.farmerMobile, 'Dashboard', '', new Date(), 'Invalid');
      }
    }, _err => {
      // this.loader.close();
      this.loading = false;
    })

    this.subscriptions.push(sub);
  }

  getDetailsByFarmerId() {
    // this.loader.start();
    this.loading = true;
    let sub = this.dashboard.getApplicationByFarmerId(this.farmerId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          res.forEach(e => {
            e.registerationDate = new Date(e.registerationDate)
            e.registerationDate_filter = e.registerationDate.toString().substring(4, 15)
          })

          // console.log(res, "result")
          this.farmerAppDetails = res;
          // this.loader.close();
          this.loading = false;
          this.appVerificationModel = this.farmerAppDetails;
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
        }
      });

    // this.subscriptions.push(sub);
  }

  getVillageData() {
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      // console.log(res);
      this.villageList = res;
      // this.loader.close();
      this.loading = false;
      this.FarmersDetailsService();
      this.filteredData = [...this.villageList];
      // console.log("fil", this.filteredData);
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    }, _err => {
      // this.loader.close();
      this.loading = false;
    })
  }

  FarmersDetailsService() {
    // this.loader.start();
    this.loading = true;
    let sub = this.dashboard.GetAllFarmerDetails()
      .pipe(first())
      .subscribe({
        next: (res) => {
          // console.log("details", res);
          this.farmerDetails = res;
          // this.loader.close();
          this.loading = false;
          this.formData = this.farmerDetails.find(x => x.Farmer_ID == this.farmerDetails[0].Farmer_ID);
          this.village = this.villageList.find(x => x.Code == this.formData.Village_Code);
          // debugger;
          // console.log("formData", this.village);
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
        }
      })

    this.subscriptions.push(sub);
  }

  editForm(appId) {
    // this.router.navigate(['farmer','farmers-application'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString())} });

    this.router.navigate(['farmer/farmers-application', this.cryptoJsService.Encrypt(appId.toString())])
  }

  deleteForm(appId) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // console.log("Hello")
        // console.log(appId)
        // this.loader.start();
        this.loading = true;
        this.dashboard.deleteFarmerApplicationByAppId(appId)
          .pipe(first())
          .subscribe({
            next: (data) => {
              // this.loader.close();
              this.loading = false;
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: data });
              this.loadData();
              this.activityRecordService.activityRecord(this.farmerMobile, 'Delete Farmer Application', appId, new Date(), data);

            },
            error: (err) => {
              // this.loader.close();
              this.activityRecordService.activityRecord(this.farmerMobile, 'Delete Farmer Application', appId, new Date(), err);

              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

            }
          });
      }
    });
  }

  // getMIDetailByAppID() {
  //  }

  // printForm(appId,vendorId,programId,userId,autoId,statusCode) {
  //   let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
  //   this.router.navigate(['dashboard', 'print',appId,vendorId,programId,userId,autoId], { queryParams: { statusCode: statusCodeEncrypted } });
  // }
  printForm(appId, _statusCode) {
    if (appId) {
      this.router.navigate(['farmer', 'dashboard', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
      
      // this.router.navigate(['farmer', 'dashboard', 'print', this.cryptoJsService.Encrypt(appId)]);

      // this.loader.start();
      // this.loading = true;
      // this.dashboard
      //   .getMIDetailByAppID(appId)
      //   .pipe(first())
      //   .subscribe({
      //     next: (res) => {
      //       // this.loader.close();
      //       this.loading = false;
      //       let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      //       this.router.navigate(['farmer', 'dashboard', 'print', this.cryptoJsService.Encrypt(appId), res[0]?.VendorId, res[0]?.ProgId, res[0]?.User_ID, res[0]?.AutoId], { queryParams: { statusCode: statusCodeEncrypted } });
      //     },
      //     error: (err) => {
      //       // this.loader.close();
      //       this.loading = false;
      //       // console.log("error", err);
      //       this.messageService.add({
      //         severity: 'error',
      //         summary: 'Error Message',
      //         detail: err,
      //       });
      //     },
      //   });

      // let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      //   this.router.navigate(['dashboard', 'print',appId], { queryParams: { statusCode: statusCodeEncrypted } });
    }
  }

  exportExcel(modelData, filename) {
    // console.log(modelData, "modelDatamodelDatamodelData")
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "App Id": d.appID,
          "farmerName": d.farmerName,
          "Reg Date": d.registerationDate_filter,
          "village": d.village,
          "Block": d.block,
          "District": d.district,
          "Status": d.status,
          "Remarks": d.remarks,
          "Fin Year": d.FinYear,
        }
      })

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(_FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "export" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }


  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'App Id' },
      { field: 'farmerName', header: 'farmerName' },
      { field: 'registerationDate_filter', header: 'Reg Date' },
      { field: 'village', header: 'village' },
      { field: 'block', header: 'Block' },
      { field: 'district', header: 'District' },
      { field: 'status', header: 'Status' },
      { field: 'remarks', header: 'Remarks' },
      { field: 'FinYear', header: 'Fin Year' },


    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(_x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
}


